import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { t } from 'i18next'
import { SidebarLeft } from '../../../components/Page/logix2020/SidebarLeft'
import SidebarNavigation from '../../../components/Page/logix2020/SidebarNavigation'
import { FlexWrapper } from '../../../components/Page/logix2020/FlexWrapper'
import { useActivitiesState } from '../../../stores/Configuration/ActivitiesProvider'
import { useAssetTypesState } from '../../../stores/Configuration/AssetTypesProvider'
import { Subheader } from '../../../components/Page/logix2020/Subheader'
import SubheaderTitle from '../../../components/Page/logix2020/SubheaderTitle'
import { ContentArea } from '../../../components/Page/logix2020/ContentArea'
import BigFooter from '../../../components/Footer/BigFooter'
import AssetTypeGeneralForm from '../../../components/Configuration/AssetTypes/AssetTypeGeneralForm'
import AssetTypeItemActivities from '../../../components/Configuration/AssetTypes/AssetTypeItemActivities'
import useMountEffect from '../../../utils/hooks/useMountEffect'
import { ButtonWithLoadingState } from '../../../components/Buttons'
import { Alert } from 'react-bootstrap'

const navigationLeft = () => {
  return [
    {
      key: '#base',
      to: '#base',
      name: t('contingentTemplates:base'),
      disabled: false,
    },
    {
      key: '#activities',
      to: '#activities',
      name: t('assetTypes:assignedActivity'),
      disabled: false,
    },
  ]
}

const EditAssetTypePage = () => {
  const currentLocation = useLocation()
  const {
    getAssetType,
    getAssignedActivities,
    successStates,
    setSuccessStates,
    resetAssetTypesPage,
    errorStates,
    setErrorStates,
  } = useAssetTypesState()
  const { getActivities } = useActivitiesState()
  const { assetTypeId } = useParams()
  const [activeNav, setActiveNav] = useState('')
  const [buttonState, setButtonState] = useState({
    handleSubmit: null,
    isChanged: false,
    isLoading: false,
  })

  useMountEffect(() => {
    resetAssetTypesPage()
    getAssetType(assetTypeId)
    getAssignedActivities(assetTypeId)
    getActivities()
  })

  useEffect(() => {
    if (successStates.saveAssetType) {
      console.log('SUCCESS FLAG RECEIVED!')
    }
    let timer = null
    if (successStates.saveAssetType) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        setSuccessStates({})
      }, 3000)
    }
    return () => clearTimeout(timer)
  }, [setSuccessStates, successStates.saveAssetType])

  useEffect(() => {
    setActiveNav(currentLocation.hash || '#base')
  }, [currentLocation.hash])

  useEffect(() => {
    setSuccessStates({})
  }, [activeNav, setSuccessStates])

  useEffect(() => {
    setErrorStates({})
  }, [activeNav, setErrorStates])

  const clearSuccess = () => setSuccessStates({})

  return (
    <div>
      <Subheader className='subHeader-v1'>
        <SubheaderTitle
          withBackButton
          smallTitle={t('assetTypes:editAssetType')}
          goBackLabel={t('assetTypes:assetTypesOverview')}
          defaultBackTo='/assetTypesAdministration'
        />
      </Subheader>
      <FlexWrapper>
        <SidebarLeft>
          <SidebarNavigation options={navigationLeft()} active={activeNav} />
          {activeNav === '#activities' && (
            <>
              <ButtonWithLoadingState
                disabled={!buttonState.isChanged}
                className='mt-4 w-100'
                buttonText={t('saveButton')}
                isLoading={buttonState.isLoading}
                onClick={buttonState.handleSubmit}
              />

              {successStates.putAssignedActivities && (
                <Alert
                  variant='success'
                  className='mt-3'
                  style={{ padding: '10px 14px' }}
                >
                  {t(`registrationBox:savingSuccess`)}
                </Alert>
              )}
              {errorStates.putAssignedActivities && (
                <Alert
                  variant='danger'
                  className='mt-3'
                  style={{ padding: '10px 14px' }}
                >
                  {errorStates.putAssignedActivities}
                </Alert>
              )}
            </>
          )}
        </SidebarLeft>
        <ContentArea>
          {activeNav === '#base' && (
            <AssetTypeGeneralForm assetTypeId={assetTypeId} />
          )}
          {activeNav === '#activities' && (
            <AssetTypeItemActivities
              onSubmitReady={setButtonState}
              onUserInteraction={clearSuccess}
            />
          )}
        </ContentArea>
      </FlexWrapper>
      <BigFooter />
    </div>
  )
}

export default EditAssetTypePage
